'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var cid = require('multiformats/cid');

var debug = require('debug');

var ipfsUnixfs = require('ipfs-unixfs');

var dirSharded = require('./dir-sharded.js');

var hamtUtils = require('./hamt-utils.js');

var errCode = require('err-code');

var last = require('it-last');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var log = debug__default["default"]('ipfs:mfs:core:utils:add-link');

function addLink(_x, _x2) {
  return _addLink.apply(this, arguments);
}

function _addLink() {
  _addLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context, options) {
    var parent, parentCid, block, meta;
    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            parent = options.parent;

            if (!options.parentCid) {
              _context6.next = 12;
              break;
            }

            parentCid = cid.CID.asCID(options.parentCid);

            if (!(parentCid === null)) {
              _context6.next = 5;
              break;
            }

            throw errCode__default["default"](new Error('Invalid CID passed to addLink'), 'EINVALIDPARENTCID');

          case 5:
            if (!(parentCid.code !== dagPB__namespace.code)) {
              _context6.next = 7;
              break;
            }

            throw errCode__default["default"](new Error('Unsupported codec. Only DAG-PB is supported'), 'EINVALIDPARENTCID');

          case 7:
            log("Loading parent node ".concat(parentCid));
            _context6.next = 10;
            return context.repo.blocks.get(parentCid);

          case 10:
            block = _context6.sent;
            parent = dagPB__namespace.decode(block);

          case 12:
            if (parent) {
              _context6.next = 14;
              break;
            }

            throw errCode__default["default"](new Error('No parent node or CID passed to addLink'), 'EINVALIDPARENT');

          case 14:
            if (options.cid) {
              _context6.next = 16;
              break;
            }

            throw errCode__default["default"](new Error('No child cid passed to addLink'), 'EINVALIDCHILDCID');

          case 16:
            if (options.name) {
              _context6.next = 18;
              break;
            }

            throw errCode__default["default"](new Error('No child name passed to addLink'), 'EINVALIDCHILDNAME');

          case 18:
            if (!(!options.size && options.size !== 0)) {
              _context6.next = 20;
              break;
            }

            throw errCode__default["default"](new Error('No child size passed to addLink'), 'EINVALIDCHILDSIZE');

          case 20:
            if (parent.Data) {
              _context6.next = 22;
              break;
            }

            throw errCode__default["default"](new Error('Parent node with no data passed to addLink'), 'ERR_INVALID_PARENT');

          case 22:
            meta = ipfsUnixfs.UnixFS.unmarshal(parent.Data);

            if (!(meta.type === 'hamt-sharded-directory')) {
              _context6.next = 26;
              break;
            }

            log('Adding link to sharded directory');
            return _context6.abrupt("return", addToShardedDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              parent: parent
            })));

          case 26:
            if (!(parent.Links.length >= options.shardSplitThreshold)) {
              _context6.next = 29;
              break;
            }

            log('Converting directory to sharded directory');
            return _context6.abrupt("return", convertToShardedDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              parent: parent,
              mtime: meta.mtime,
              mode: meta.mode
            })));

          case 29:
            log("Adding ".concat(options.name, " (").concat(options.cid, ") to regular directory"));
            return _context6.abrupt("return", addToDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              parent: parent
            })));

          case 31:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));
  return _addLink.apply(this, arguments);
}

var convertToShardedDirectory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, options) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return hamtUtils.createShard(context, options.parent.Links.map(function (link) {
              return {
                name: link.Name || '',
                size: link.Tsize || 0,
                cid: link.Hash
              };
            }).concat({
              name: options.name,
              size: options.size,
              cid: options.cid
            }), options);

          case 2:
            result = _context.sent;
            log("Converted directory to sharded directory ".concat(result.cid));
            return _context.abrupt("return", result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function convertToShardedDirectory(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var addToDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, options) {
    var parentLinks, node, data, ms, secs, hasher, buf, hash, cid$1;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parentLinks = options.parent.Links.filter(function (link) {
              return link.Name !== options.name;
            });
            parentLinks.push({
              Name: options.name,
              Tsize: options.size,
              Hash: options.cid
            });

            if (options.parent.Data) {
              _context2.next = 4;
              break;
            }

            throw errCode__default["default"](new Error('Parent node with no data passed to addToDirectory'), 'ERR_INVALID_PARENT');

          case 4:
            node = ipfsUnixfs.UnixFS.unmarshal(options.parent.Data);

            if (node.mtime) {
              ms = Date.now();
              secs = Math.floor(ms / 1000);
              node.mtime = {
                secs: secs,
                nsecs: (ms - secs * 1000) * 1000
              };
              data = node.marshal();
            } else {
              data = options.parent.Data;
            }

            options.parent = dagPB__namespace.prepare({
              Data: data,
              Links: parentLinks
            });
            _context2.next = 9;
            return context.hashers.getHasher(options.hashAlg);

          case 9:
            hasher = _context2.sent;
            buf = dagPB__namespace.encode(options.parent);
            _context2.next = 13;
            return hasher.digest(buf);

          case 13:
            hash = _context2.sent;
            cid$1 = cid.CID.create(options.cidVersion, dagPB__namespace.code, hash);

            if (!options.flush) {
              _context2.next = 18;
              break;
            }

            _context2.next = 18;
            return context.repo.blocks.put(cid$1, buf);

          case 18:
            return _context2.abrupt("return", {
              node: options.parent,
              cid: cid$1,
              size: buf.length
            });

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addToDirectory(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var addToShardedDirectory = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, options) {
    var _yield$addFileToShard, shard, path, result, block, node, parentLinks, newLink;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return addFileToShardedDirectory(context, options);

          case 2:
            _yield$addFileToShard = _context3.sent;
            shard = _yield$addFileToShard.shard;
            path = _yield$addFileToShard.path;
            _context3.next = 7;
            return last__default["default"](shard.flush(context.repo.blocks));

          case 7:
            result = _context3.sent;

            if (result) {
              _context3.next = 10;
              break;
            }

            throw new Error('No result from flushing shard');

          case 10:
            _context3.next = 12;
            return context.repo.blocks.get(result.cid);

          case 12:
            block = _context3.sent;
            node = dagPB__namespace.decode(block);
            parentLinks = options.parent.Links.filter(function (link) {
              return (link.Name || '').substring(0, 2) !== path[0].prefix;
            });
            newLink = node.Links.find(function (link) {
              return (link.Name || '').substring(0, 2) === path[0].prefix;
            });

            if (newLink) {
              _context3.next = 18;
              break;
            }

            throw new Error("No link found with prefix ".concat(path[0].prefix));

          case 18:
            parentLinks.push(newLink);
            return _context3.abrupt("return", hamtUtils.updateHamtDirectory(context, parentLinks, path[0].bucket, options));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function addToShardedDirectory(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var addFileToShardedDirectory = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, options) {
    var file, rootBucket, node, shard, position, path, index, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            file = {
              name: options.name,
              cid: options.cid,
              size: options.size
            };

            if (options.parent.Data) {
              _context5.next = 3;
              break;
            }

            throw errCode__default["default"](new Error('Parent node with no data passed to addFileToShardedDirectory'), 'ERR_INVALID_PARENT');

          case 3:
            _context5.next = 5;
            return hamtUtils.recreateInitialHamtLevel(options.parent.Links);

          case 5:
            rootBucket = _context5.sent;
            node = ipfsUnixfs.UnixFS.unmarshal(options.parent.Data);
            shard = new dirSharded.DirSharded({
              root: true,
              dir: true,
              parent: undefined,
              parentKey: undefined,
              path: '',
              dirty: true,
              flat: false,
              mode: node.mode
            }, options);
            shard._bucket = rootBucket;

            if (node.mtime) {
              shard.mtime = {
                secs: Math.round(Date.now() / 1000)
              };
            }

            _context5.next = 12;
            return rootBucket._findNewBucketAndPos(file.name);

          case 12:
            position = _context5.sent;
            path = toBucketPath(position);
            path[0].node = options.parent;
            index = 0;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var segment, node, link, block, subShard, _position, nextSegment;

              return _regeneratorRuntime.wrap(function _loop$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      segment = path[index];
                      index++;
                      node = segment.node;

                      if (node) {
                        _context4.next = 5;
                        break;
                      }

                      throw new Error('Segment had no node');

                    case 5:
                      link = node.Links.find(function (link) {
                        return (link.Name || '').substring(0, 2) === segment.prefix;
                      });

                      if (link) {
                        _context4.next = 10;
                        break;
                      }

                      log("Link ".concat(segment.prefix).concat(file.name, " will be added"));
                      index = path.length;
                      return _context4.abrupt("return", "break");

                    case 10:
                      if (!(link.Name === "".concat(segment.prefix).concat(file.name))) {
                        _context4.next = 14;
                        break;
                      }

                      log("Link ".concat(segment.prefix).concat(file.name, " will be replaced"));
                      index = path.length;
                      return _context4.abrupt("return", "break");

                    case 14:
                      if (!((link.Name || '').length > 2)) {
                        _context4.next = 18;
                        break;
                      }

                      log("Link ".concat(link.Name, " ").concat(link.Hash, " will be replaced with a subshard"));
                      index = path.length;
                      return _context4.abrupt("return", "break");

                    case 18:
                      log("Found subshard ".concat(segment.prefix));
                      _context4.next = 21;
                      return context.repo.blocks.get(link.Hash);

                    case 21:
                      block = _context4.sent;
                      subShard = dagPB__namespace.decode(block);

                      if (path[index]) {
                        _context4.next = 32;
                        break;
                      }

                      log("Loaded new subshard ".concat(segment.prefix));
                      _context4.next = 27;
                      return hamtUtils.recreateHamtLevel(context, subShard.Links, rootBucket, segment.bucket, parseInt(segment.prefix, 16));

                    case 27:
                      _context4.next = 29;
                      return rootBucket._findNewBucketAndPos(file.name);

                    case 29:
                      _position = _context4.sent;
                      path.push({
                        bucket: _position.bucket,
                        prefix: hamtUtils.toPrefix(_position.pos),
                        node: subShard
                      });
                      return _context4.abrupt("return", "break");

                    case 32:
                      nextSegment = path[index];
                      _context4.next = 35;
                      return hamtUtils.addLinksToHamtBucket(context, subShard.Links, nextSegment.bucket, rootBucket);

                    case 35:
                      nextSegment.node = subShard;

                    case 36:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _loop);
            });

          case 17:
            if (!(index < path.length)) {
              _context5.next = 24;
              break;
            }

            return _context5.delegateYield(_loop(), "t0", 19);

          case 19:
            _ret = _context5.t0;

            if (!(_ret === "break")) {
              _context5.next = 22;
              break;
            }

            return _context5.abrupt("break", 24);

          case 22:
            _context5.next = 17;
            break;

          case 24:
            _context5.next = 26;
            return shard._bucket.put(file.name, {
              size: file.size,
              cid: file.cid
            });

          case 26:
            return _context5.abrupt("return", {
              shard: shard,
              path: path
            });

          case 27:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));

  return function addFileToShardedDirectory(_x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var toBucketPath = function toBucketPath(position) {
  var path = [{
    bucket: position.bucket,
    prefix: hamtUtils.toPrefix(position.pos)
  }];
  var bucket = position.bucket._parent;
  var positionInBucket = position.bucket._posAtParent;

  while (bucket) {
    path.push({
      bucket: bucket,
      prefix: hamtUtils.toPrefix(positionInBucket)
    });
    positionInBucket = bucket._posAtParent;
    bucket = bucket._parent;
  }

  path.reverse();
  return path;
};

exports.addLink = addLink;